import { LeadDetailsModel } from '@/typings/models/Lead';
import { useState } from 'react';
import { Button, Popconfirm, Space } from 'antd';
import PERMISSIONS from '@/constants/permissions';
import { F } from '@/utils/intl';
import { CheckAccess } from '@/utils/access';
import { InboxOutlined, UndoOutlined } from '@ant-design/icons';
import { editLeadsRequest } from '@/services/api/lead';
import styles from './index.less';

export default function ArchiveAction({ leadData }: { leadData: LeadDetailsModel }) {
  const [archivePopoverOpen, setArchivePopoverOpen] = useState<boolean>();
  const [loading, setLoading] = useState(false);

  const handleActionClick = () => {
    return new Promise((resolve, reject) => {
      setLoading(true);
      editLeadsRequest({
        params: {
          leadId: leadData.id,
        },
        data: {
          is_archived: !leadData.is_archived,
        },
      }).then(() => {
        resolve();
        setLoading(false);
      });
    });
  };
  return (
    <CheckAccess
      access={[PERMISSIONS.Leads.ARCHIVE, PERMISSIONS.BUSINESS_PARTNER]}
    >
      {!leadData.is_archived ? (
        <Popconfirm
          placement={'right'}
          open={archivePopoverOpen}
          onOpenChange={setArchivePopoverOpen}
          onConfirm={handleActionClick}
          title={
            <F
              id={'pages.lead.action.archive.confirmation'}
              defaultMessage={'Are you sure to archive this lead?'}
            />
          }
        >
          <Button
            loading={loading}
            type={'text'}
            size={'small'}
            className={styles.archiveButton}
          >
            <Space>
              <InboxOutlined />
              <F id={'pages.lead.action.archive'} defaultMessage={'archive'} />
            </Space>
          </Button>
        </Popconfirm>
      ) : (
        <Button
          loading={loading}
          onClick={handleActionClick}
          type={'text'}
          size={'small'}
          className={styles.archiveButton}
        >
          <Space>
            <UndoOutlined />
            <F
              id={'pages.lead.action.unarchive'}
              defaultMessage={'Unarchive'}
            />
          </Space>
        </Button>
      )}
    </CheckAccess>
  );
}
